module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn--full-width btn--cta-red",
    attrs: {
      "href": this.getPromoUrl,
      "target": "_blank"
    }
  }, [_vm._v("Kalkuluj")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28472627","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calculateButton.vue
// module id = 366
// module chunks = 0